import { helpers } from "@vuelidate/validators"

export function conditionalRule(parameters) {
  if (!parameters.when()) {
    return {}
  }

  return helpers.withMessage(
    parameters.message,
    parameters.validator
  )
}
